// @flow
import * as api from "../data/firebase-data";
import * as actionTypes from "../constants/action-types";
import type User from "../models/user";


/** EXAMPLE ACTIONS

 ***ASYNC EXAMPLE:

 export const doSomeAction = (foo): (any => void) => {
    function thunk(dispatch) {
        someAsyncFunction(foo)
            .then((result: mixed) => {
                dispatch({ type: actionTypes.SOME_ACTION_SUCCESS, payload: {result}});
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.SOME_ACTION_FAIL, payload: {error} });
            });
    }
    thunk.interceptOnOffline = true;
    return thunk;
};


 ***SYNCHRONOUS EXAMPLE:

 export const soSomeAction = (api: DataType): ActionType => (
 {
        type: actionTypes.SOME_ACTION,
        api
    }
 ); export const doSomeAction =

 **/

export const saveUser = (user: User): (any => void) => {
    function thunk(dispatch) {
        api.updateUser(user)
            .then((result: mixed) => {
                dispatch({ type: actionTypes.UPDATE_USER_SUCCESS, payload: { result } });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.UPDATE_USER_FAIL, payload: { error } });
            });
    }

    thunk.interceptOnOffline = true;
    return thunk;
};


export const saveAdmin = (user: User, isAdmin: boolean): (any => void) => {
    const record = { email: user.email, displayName: user.displayName, isAdmin, updated: new Date() };

    function thunk(dispatch) {
        api.updateAdmin(user.uid, record)
            .then(() => {
                dispatch({ type: actionTypes.UPDATE_ADMIN_SUCCESS, payload: User.create({ ...user, isAdmin }) });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.UPDATE_ADMIN_FAIL, payload: { error } });
            });
    }

    thunk.interceptOnOffline = true;
    return thunk;
};


